import axios from "axios"

interface ContactInterface {
    name: string,
    icon: string
}


// Get all types of contact
async function getContactTypesApi() {
    return axios({
        method: "GET",
        url: '/api/v1/contact-types'
    })
}

// Create new contact type
async function postContactTypeApi(data: ContactInterface){
    return axios({
        method: "POST",
        url: '/api/v1/contact-types',
        data
    })
}

export {
    getContactTypesApi,
    postContactTypeApi
}